import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '.';

export const TranslationProvider = ({ children }: React.PropsWithChildren) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
